import { atom } from "recoil";
import { User, Columns, Filters } from "../types/index";

export const isOnlySearchState = atom({
  key: "isOnlySearchState",
  default: false,
});

export const isActiveFetchState = atom({
  key: "isActiveFetchState",
  default: false,
});
